import React, { useState } from "react";
import {
    Box,
    Typography,
    Divider,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TextField
} from "@mui/material";

import { useGetArchivedProductsQuery } from "../../../redux/slices/admin/product/archiveProductSlince.js";
import { useOutletContext } from "react-router-dom";
import { Pagination } from "@mui/material";
import "../../../styles/admin.css/products-css/archived-products.css";


export default function ArchivedProducts() {
    const { sidebarOpen } = useOutletContext();
    const [page, setPage] = useState(1);
    const itemsPerPage = 50;


    const { data: productsData = [], isLoading: productsLoading, refetch } = useGetArchivedProductsQuery(undefined, {
        refetchOnMountOrArgChange: true,
        refetchOnFocus: true,
    });

    const [search, setSearch] = useState("");

    const filteredProducts = productsData.data?.filter(prod =>
        prod.name?.toLowerCase().includes(search.toLowerCase())
    ) || [];


    const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);
    const startIndex = (page - 1) * itemsPerPage;
    const paginatedProducts = filteredProducts.slice(startIndex, startIndex + itemsPerPage);
    React.useEffect(() => {
        setPage(1);
    }, [search]);

    return (
        <Box className={`archived-products-container ${sidebarOpen ? "sidebar-open" : ""}`}>
            <Box className="archived-products-header">
                <Box className="archived-products-title">
                    <Typography style={{ color: "#545A61" }}>
                        Siyahıdan çıxarılmış məhsullar
                    </Typography>
                    <Divider className="archived-products-divider" />
                </Box>

                <Box className="archived-products-filter-row">
                    <TextField
                        size="small"
                        placeholder="Axtar..."
                        className="archived-products-search-input"
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </Box>
            </Box>

            <TableContainer component={Paper} className="archived-products-table" style={{ overflow: "visible" }}>
                <Table>
                    <TableHead>
                        <TableRow>
                            <TableCell><strong>#No</strong></TableCell>
                            <TableCell><strong>Məhsul Adı</strong></TableCell>
                            <TableCell><strong>Kateqoriya</strong></TableCell>
                            <TableCell><strong>Alt-kateqoriya</strong></TableCell>
                            <TableCell><strong>Satış Qiyməti</strong></TableCell>
                            <TableCell><strong>Çıxarış tarixi</strong></TableCell>
                        </TableRow>
                    </TableHead>

                    <TableBody>
                        {productsLoading ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">Yüklənir...</TableCell>
                            </TableRow>
                        ) : paginatedProducts.length === 0 ? (
                            <TableRow>
                                <TableCell colSpan={6} align="center">
                                    Məlumat tapılmadı
                                </TableCell>
                            </TableRow>
                        ) : (
                            paginatedProducts.map((prod, index) => (
                                <TableRow key={prod.id}>
                                    <TableCell>{"#" + String(prod.serialNo || prod.id).padStart(4, "0")}</TableCell>
                                    <TableCell>{prod.name || "-"}</TableCell>
                                    <TableCell>{prod.categoryName || "-"}</TableCell>
                                    <TableCell>{prod.subcategoryName || "-"}</TableCell>
                                    <TableCell>
                                        {prod.sellPrice != null ?
                                            `${Number(prod.sellPrice) % 1 === 0 ? Number(prod.sellPrice) : prod.sellPrice}₼`
                                            : "-"
                                        }
                                    </TableCell>

                                    <TableCell>
                                        {prod.archivedAt
                                            ? new Date(prod.archivedAt).toLocaleString()
                                            : "-"
                                        }
                                    </TableCell>

                                </TableRow>
                            ))
                        )}
                    </TableBody>
                </Table>
            </TableContainer>
            {filteredProducts.length > itemsPerPage && (
                <Box sx={{ display: 'flex', justifyContent: 'right', p: 3, mt: 2 }}>
                    <Pagination
                        count={totalPages}
                        page={page}
                        onChange={(e, value) => {
                            setPage(value);
                            window.scrollTo({ top: 0, behavior: 'smooth' });
                        }}
                        color="primary"
                        variant="outlined"
                        shape="rounded"
                    />
                </Box>
            )}
        </Box>
    );
}
